<template>
    <el-container class="appModelMenu">
        <el-aside width="229px">
             <div :style="activeStyle()">
                <div  class="el-menu-vertical-demo">
                    <el-menu
                        :default-active="defaultAppIndex"
                        v-for="(appSystem, sysIndex) in menuList"
                        :key="appSystem.taskId"
                        :index="appSystem.taskId"
                        :unique-opened="true"
                        @open="handleOpen"
                        @close="handleClose"
                        :collapse="isCollapse?false:true"
                        >
                        <el-submenu  :index="appSystem.taskId">
                            <template slot="title">
                                <span slot="title">
                                    {{appSystem.taskName}}
                                </span>
                            </template>
                            <el-menu-item
                                v-for="(subModel, smIndex) in appSystem.subModel"
                                :key="subModel.taskId"
                                :index="subModel.taskId"
                                @click="handleClickMenu(subModel)"
                                >
                                <span slot="title">
                                    {{subModel.taskName}}
                                </span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </div>
        </el-aside>
    </el-container>
</template>

<script>
export default {
    data () {
        return {
            isCollapse: true
        };
    },
    computed: {
        // defaultActive() {
        //     return '/' + this.$route.path.split('/').reverse()[0];
        // }
    },
    created () {
        this._initPage();
    },
    props: {
        menuList: {
            type: Array
        },
        defaultAppIndex: {
            type: String
        },
        fullScreen: {
            type: Boolean,
            default: false
        },
        isNewMenu: {// 是否新菜单引用
            type: Boolean,
            default: false
        }
    },
    methods: {
        _initPage () {
            if (this.defaultAppIndex !== '') {
                this.handleClickMenu({taskId: this.defaultAppIndex});
            }
        },
        handleOpen (key, keyPath) {
        },
        handleClose (key, keyPath) {
        },
        handleClickMenu (model) {
            this.$emit('nodeClick', model);
        },
        changeSwitch () {
            let width = this.isCollapse ? '230px' : '35px';
            this.$emit('setMenuWidth', width);
        },
        activeStyle () {
            let style = {};
            if (this.fullScreen) {
                style = {
                    'height': '575px',
                    'overflow-y': 'auto'
                };
            } else {
                style = {
                    'height': 'auto',
                    'overflow-y': 'auto'
                };
            }
            return style;
        }
    }
};
</script>

<style>
    .sidebar-container,.el-menu {
        height: 100%;
        overflow: auto;
    }
    .el-aside,.el-main {
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/TaskNodeMenu/TaskNodeMenu.vue